module.exports = "#version 300 es\n\nprecision highp float;\n\nin vec4 vs_Pos;\nout vec4 fs_Pos;\n\nuniform vec2 u_AspectRatio;\n\nvoid main() {\n\tfs_Pos = vs_Pos;\n\tgl_Position = vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/screenspace-vert.glsl
// module id = 66
// module chunks = 0